class QuantityPicker extends HTMLElement {
  constructor() {
    super();
    this.handleChange = this.onChange.bind(this);
    this.handlePageShow = this.onPageShow.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.attachEventListeners();
    this.getDataFromDocument();
    this.resync();
  }

  disconnectedCallback() {
    this._initialized = false;
    this.removeEventListener('change', this.handleChange);
    window.removeEventListener('pageshow', this.handlePageShow);
  }

  resync() {
    if (this.benefitsData && this.benefitTemplate) {
      this.changeBenefits(this.selectedInput.value);
    }
    this.syncSelectedQuantity();
  }

  attachEventListeners() {
    this.addEventListener('change', this.handleChange);
    window.addEventListener('pageshow', this.handlePageShow)
  }

  getDataFromDocument() {
    const benefitsDataElement = document.querySelector("[data-subscription-benefits]");
    if (!benefitsDataElement) return;
    this.benefitsData = JSON.parse(benefitsDataElement.textContent);
    this.benefitTemplate = document.querySelector("[data-benefit-template]");
  }

  get sectionRoot() {
    return this.closest('[id^="shopify-section-"]') || document;
  }

  get productFormId() {
    return this.dataset.productFormId || null;
  }

  get addToCartForms() {
    if (this.productFormId) {
      const formById = document.getElementById(this.productFormId);
      if (formById && this.sectionRoot.contains(formById)) return [formById];
    }

    return [...this.sectionRoot.querySelectorAll('form[action*="/cart/add"]')];
  }

  get selectedInput() {
    return (
      this.querySelector('input[name="quantity-picker"]:checked') ||
      this.querySelector('input[name="quantity-picker"]')
    );
  }

  getQuantityValue(input) {
    const parsed = Number.parseInt(input.value || input.dataset.quantity, 10);
    return Number.isNaN(parsed) || parsed < 1 ? 1 : parsed;
  }

  getFormQuantityInputs(form) {
    const directInputs = [...form.querySelectorAll('input[name="quantity"]')];
    const externalInputs = form.id ? [...this.sectionRoot.querySelectorAll(`input[name="quantity"][form="${form.id}"]`)]
      : [];
    const allInputs = [...new Set([...directInputs, ...externalInputs])];

    if (allInputs.length > 0) return allInputs;

    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'quantity';
    hiddenInput.value = '1';
    form.appendChild(hiddenInput);

    return [hiddenInput];
  }

  syncQuantityToForms(quantity) {
    this.addToCartForms.forEach((form) => {
      this.getFormQuantityInputs(form).forEach((input) => {
        input.value = String(quantity);
      })
    })
  }

  syncSelectedQuantity() {
    if (!this.selectedInput) return;
    this.syncQuantityToForms(this.getQuantityValue(this.selectedInput));
  }

  onPageShow(event) {
    if (!event.persisted) return;

    this.resync();
  }

  onChange(event) {
    const input = event.target.closest('input[name="quantity-picker"]');
    if (!input || !input.checked) return;

    const quantity = this.getQuantityValue(input);
    this.syncQuantityToForms(quantity);
    this.changeBenefits(quantity);
  }

  changeBenefits(quantity) {
    const currentBenefits = this.benefitsData[`quantityBenefits-${quantity}`];

    const benefitsList = document.querySelector("[data-benefits-list]");
    if (!benefitsList || !currentBenefits) return;

    benefitsList.replaceChildren();

    currentBenefits?.forEach(benefit => {
      const benefitElement = this.benefitTemplate?.content.cloneNode(true);
      if (!benefitElement) return;

      benefitElement.querySelector("[data-benefit-text]").innerText = benefit;
      benefitsList.appendChild(benefitElement);
    });
  }
}

if (!customElements.get('quantity-picker')) {
  customElements.define('quantity-picker', QuantityPicker);
}